<template>
  <div class="page-view">
    <div class="header-row">
      <div>
        <h2>订单详情</h2>
        <p>查看完整订单信息、敏感字段访问记录和最近审计日志。</p>
      </div>
      <div>
        <el-button plain @click="$router.back()">返回</el-button>
        <el-button type="primary" plain @click="loadData">刷新</el-button>
      </div>
    </div>

    <div v-if="detail.id" class="detail-grid">
      <div class="brand-card panel-card">
        <h3>基础信息</h3>
        <div class="info-grid">
          <div><span>订单号</span><strong>{{ detail.order_no }}</strong></div>
          <div><span>订单状态</span><strong>{{ detail.status }}</strong></div>
          <div><span>宣传方案</span><strong>{{ detail.promotion_plan || "-" }}</strong></div>
          <div><span>产品名称</span><strong>{{ detail.product_name || "-" }}</strong></div>
          <div><span>业务类型</span><strong>{{ detail.business_type || "-" }}</strong></div>
          <div><span>收件人</span><strong>{{ detail.recipient_name }}</strong></div>
          <div><span>联系电话</span><strong>{{ sensitive.recipient_phone || detail.recipient_phone || "-" }}</strong></div>
          <div><span>身份证号</span><strong>{{ sensitive.id_card_no || detail.id_card_no || "-" }}</strong></div>
          <div><span>办卡人手机号</span><strong>{{ sensitive.card_holder_phone || detail.card_holder_phone || "-" }}</strong></div>
          <div><span>归属团队</span><strong>{{ detail.team_name || "-" }}</strong></div>
          <div><span>支付方式</span><strong>{{ detail.payment_type || "-" }}</strong></div>
          <div><span>期望配送时间</span><strong>{{ detail.expected_delivery_date || "-" }}</strong></div>
          <div><span>配送时间段</span><strong>{{ detail.delivery_time_range || "-" }}</strong></div>
          <div><span>是否加急</span><strong>{{ detail.is_urgent ? "是" : "否" }}</strong></div>
          <div><span>应收金额</span><strong>{{ detail.receivable_amount ?? "-" }}</strong></div>
          <div><span>实收金额</span><strong>{{ detail.actual_amount ?? "-" }}</strong></div>
          <div><span>是否新开户</span><strong>{{ detail.is_new_account ? "是" : "否" }}</strong></div>
          <div><span>建单来源</span><strong>{{ displayOrderSource(detail.source, detail.upstream_app_name) }}</strong></div>
          <div><span>上游单号</span><strong>{{ detail.upstream_order_no || "-" }}</strong></div>
          <div><span>下游应用</span><strong>{{ detail.downstream_app_name || "-" }}</strong></div>
          <div><span>建单人</span><strong>{{ detail.created_by_name || "-" }}</strong></div>
          <div><span>创建时间</span><strong>{{ detail.created_at || "-" }}</strong></div>
          <div><span>提交待审核时间</span><strong>{{ detail.submitted_review_at || "-" }}</strong></div>
          <div><span>完成时间</span><strong>{{ detail.completed_at || "-" }}</strong></div>
          <div><span>失败时间</span><strong>{{ detail.failed_at || "-" }}</strong></div>
        </div>
      </div>

      <div class="brand-card panel-card">
        <h3>地址与归属</h3>
        <div class="info-grid">
          <div><span>省</span><strong>{{ detail.province_name || "-" }}</strong></div>
          <div><span>市</span><strong>{{ detail.city_name || "-" }}</strong></div>
          <div><span>区县</span><strong>{{ detail.district_name || "-" }}</strong></div>
          <div><span>街道号码</span><strong>{{ detail.street_no || "-" }}</strong></div>
          <div class="full-row"><span>详细地址</span><strong>{{ sensitive.detail_address || detail.detail_address || "-" }}</strong></div>
          <div><span>归属管理员</span><strong>{{ detail.manager_name || "-" }}</strong></div>
          <div><span>归属业务员</span><strong>{{ detail.sales_name || "-" }}</strong></div>
          <div><span>归属配送员</span><strong>{{ detail.courier_name || "-" }}</strong></div>
          <div><span>抢单距离</span><strong>{{ formatGrabDistance(detail.grab_distance_meters) }}</strong></div>
          <div><span>新开手机号</span><strong>{{ sensitive.new_phone || detail.new_phone || "-" }}</strong></div>
          <div><span>首充金额</span><strong>{{ detail.first_recharge_amount ?? "-" }}</strong></div>
          <div><span>改约时间</span><strong>{{ detail.reschedule_time || "-" }}</strong></div>
        </div>
        <div class="remark-box">
          <p><strong>订单备注：</strong>{{ detail.remark || "无" }}</p>
          <p><strong>改约备注：</strong>{{ detail.reschedule_remark || "无" }}</p>
          <p><strong>失败原因：</strong>{{ detail.failure_remark || "无" }}</p>
          <p><strong>完成备注：</strong>{{ detail.completion_remark || "无" }}</p>
        </div>
      </div>
    </div>

    <div class="brand-card panel-card">
      <div class="section-row">
        <h3>敏感字段</h3>
        <div class="section-actions">
          <el-button size="mini" plain @click="viewSensitive('recipient_phone')">查看收件人手机号</el-button>
          <el-button size="mini" plain @click="viewSensitive('id_card_no')">查看身份证号</el-button>
          <el-button size="mini" plain @click="viewSensitive('detail_address')">查看地址</el-button>
          <el-button size="mini" plain @click="viewSensitive('new_phone')">查看新开号码</el-button>
          <el-button size="mini" plain @click="viewSensitive('card_holder_phone')">查看办卡人手机号</el-button>
        </div>
      </div>
      <div class="sensitive-grid">
        <div><span>收件人手机号</span><strong>{{ sensitive.recipient_phone || "点击查看" }}</strong></div>
        <div><span>身份证号</span><strong>{{ sensitive.id_card_no || "点击查看" }}</strong></div>
        <div><span>地址</span><strong>{{ sensitive.detail_address || "点击查看" }}</strong></div>
        <div><span>新开号码</span><strong>{{ sensitive.new_phone || "点击查看" }}</strong></div>
        <div><span>办卡人手机号</span><strong>{{ sensitive.card_holder_phone || "点击查看" }}</strong></div>
      </div>
    </div>

    <div class="brand-card panel-card">
      <div class="section-row">
        <h3>订单附件</h3>
        <span class="section-tip">共 {{ attachments.length }} 个</span>
      </div>
      <el-table v-if="attachments.length" :data="attachments" stripe>
        <el-table-column prop="file_type" label="类型" min-width="90">
          <template slot-scope="{ row }">
            {{ row.file_type === "audio" ? "录音" : "图片" }}
          </template>
        </el-table-column>
        <el-table-column prop="file_name" label="文件名称" min-width="160" />
        <el-table-column prop="file_url" label="访问地址" min-width="260">
          <template slot-scope="{ row }">
            <template v-if="row.file_type === 'audio'">
              <audio controls :src="row.file_url" style="width: 240px;"></audio>
            </template>
            <template v-else>
              <a :href="row.file_url" target="_blank" rel="noopener noreferrer">{{ row.file_url }}</a>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="expire_at" label="过期时间" min-width="180" />
      </el-table>
      <el-empty v-else description="暂无附件" :image-size="80" />
    </div>

    <div class="brand-card panel-card">
      <div class="section-row">
        <h3>最近日志</h3>
      </div>
      <el-table :data="logs" stripe>
        <el-table-column prop="created_at" label="时间" min-width="180" />
        <el-table-column prop="operator_name" label="操作人" min-width="120" />
        <el-table-column prop="action_type" label="类型" min-width="160" />
        <el-table-column prop="action_content" label="内容" min-width="300" />
      </el-table>
    </div>
  </div>
</template>

<script>
import http from "../api/http";
import { fetchAuditLogs, fetchOrderDetail } from "../api/orders";

export default {
  data() {
    return {
      detail: {},
      logs: [],
      attachments: [],
      sensitive: { recipient_phone: "", id_card_no: "", detail_address: "", new_phone: "", card_holder_phone: "" },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    displayOrderSource(source, upstreamAppName = "") {
      if (source === "api") {
        return upstreamAppName ? `api接入：${upstreamAppName}` : "api接入";
      }
      if (source === "manual") {
        return "手工录入";
      }
      return source || "-";
    },
    formatGrabDistance(value) {
      if (value === null || value === undefined || value === "") return "未记录";
      const meters = Number(value);
      if (!Number.isFinite(meters)) return "未记录";
      if (meters >= 1000) return `${(meters / 1000).toFixed(1)}km`;
      return `${meters}m`;
    },
    async loadData() {
      const orderId = this.$route.params.id;
      const [{ data: detail }, { data: logData }] = await Promise.all([
        fetchOrderDetail(orderId),
        fetchAuditLogs({ order_id: orderId, page: 1, page_size: 10 }),
      ]);
      this.detail = detail;
      this.attachments = detail.attachments || [];
      this.logs = logData.items || [];
    },
    async viewSensitive(field) {
      const { data } = await http.get(`/orders/${this.$route.params.id}/sensitive`, { params: { field } });
      this.$set(this.sensitive, field, data.value);
      const { data: logData } = await fetchAuditLogs({ order_id: this.$route.params.id, page: 1, page_size: 10 });
      this.logs = logData.items || [];
    },
  },
};
</script>

<style scoped>
.detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; margin-bottom: 18px; }
.panel-card { margin-bottom: 18px; }
.panel-card h3 { margin: 0 0 16px; }
.info-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; }
.full-row { grid-column: 1 / -1; }
.info-grid span, .sensitive-grid span { display: block; margin-bottom: 6px; color: #60718f; font-size: 13px; }
.info-grid strong, .sensitive-grid strong { font-size: 15px; color: #1d2b53; }
.remark-box { margin-top: 18px; padding: 16px; border-radius: 14px; background: #f6f9ff; color: #385074; }
.remark-box p { margin: 0 0 10px; }
.remark-box p:last-child { margin-bottom: 0; }
.section-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.section-actions { display: flex; gap: 8px; }
.section-tip { color: #60718f; font-size: 13px; }
.sensitive-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
</style>
